export const PANEL_WIDTH = 400

const styles = (theme) => ({
  panel: {
    position: 'relative',
    width: 0,
    overflow: 'hidden',
    flexShrink: 0,
    zIndex: theme.zIndex.drawer + 101,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    [theme.breakpoints.down('sm')]: {
      position: 'fixed',
      top: 0,
      right: 0,
      bottom: 0,
      height: '100%',
    },
  },
  panelOpen: {
    padding: theme.spacing(1.5, 1.5, 1.5, 0),
    [theme.breakpoints.down('md')]: {
      width: PANEL_WIDTH,
      padding: theme.spacing(1.5, 1.5, 1.5, 1.5),
    },
    [theme.breakpoints.down('xs')]: {
      width: '100vw',
      padding: 0,
    },
  },
  panelNoTransition: {
    transition: 'none !important',
  },
  panelWithBanner: {
    [theme.breakpoints.down('sm')]: {},
  },
  resizeHandle: {
    position: 'absolute',
    left: 0,
    top: 0,
    bottom: 0,
    width: 6,
    cursor: 'ew-resize',
    zIndex: 10,
    borderRadius: '0 3px 3px 0',
    transition: 'background-color 0.2s ease',
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
      opacity: 0.25,
    },
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
})

export default styles
